import { render, staticRenderFns } from "./LevelIntroScreen.vue?vue&type=template&id=8fcc7536&scoped=true&lang=pug&"
import script from "./LevelIntroScreen.vue?vue&type=script&lang=js&"
export * from "./LevelIntroScreen.vue?vue&type=script&lang=js&"
import style0 from "./LevelIntroScreen.vue?vue&type=style&index=0&id=8fcc7536&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcc7536",
  null
  
)

export default component.exports